import React from "react";
import { render } from "react-dom";

import SitesList from "../../apps/SitesList/components/SitesList";

export default props => {
  const element = document.getElementById("site-streams-list");
  render(<SitesList {...props} />, element);
};
